import React, {useState, useEffect} from 'react'

import { Box } from '@mui/system'
import { TextField, Button } from '@mui/material'
import Sidebar from './sidebar'
import { DataGrid } from '@mui/x-data-grid'
import { db } from '../firebase'
import dayjs from 'dayjs'


import { collection, query, getDocs } from "firebase/firestore"; 

import { useNavigate } from 'react-router-dom'
import CustomToolbar from './CustomToolbarPrint'
import { Summarize } from '@mui/icons-material'

export default function Services() {
    const [date1, setdate1] = useState("")
    const [date2, setdate2] = useState("")
    const [rows, setRows] = useState([])
    const [rows1, setRows1] = useState([])

    let arr = [];

    let sum ={
      id: Date.now(),
      candidates: 0,
      meals:0,
      showers:0,
      parcels:0,
      male:0,
      female:0,
      others:0,
      probaition: 0,
      nonClientFood: 0,
      starterPacks: 0,
      refugeeStarter: 0,
      sleepingBags: 0

    }
  
  async function getData (){
    console.log("me chala")
    let arr = []
    let arr1 = []
    const q = query(collection(db, "dailySumbissions"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      let obj = doc.data();
      Object.assign(obj, {doc: doc.id});
      console.log(obj)
      
      if(dateCheck(date1,date2,obj.date)){
        arr.push(obj)
        sum.candidates = parseInt(sum.candidates) + parseInt(obj.candidates)
        sum.meals = parseInt(sum.meals) + parseInt(obj.meals)
        sum.showers = parseInt(sum.showers) + parseInt(obj.showers)
        sum.parcels = parseInt(sum.parcels) + parseInt(obj.parcels)
        sum.male = parseInt(sum.male) + parseInt(obj.male)
        sum.female = parseInt(sum.female) + parseInt(obj.female)
        sum.others = parseInt(sum.others) + parseInt(obj.others)
        sum.probaition = parseInt(sum.probaition) + parseInt(obj.probaition)
        sum.nonClientFood = parseInt(sum.nonClientFood) + parseInt(obj.nonClientFood)
        sum.starterPacks = parseInt(sum.starterPacks) + parseInt(obj.starterPacks)
        sum.refugeeStarter = parseInt(sum.refugeeStarter) + parseInt(obj.refugeeStarter)
        sum.sleepingBags = parseInt(sum.sleepingBags) + parseInt(obj.sleepingBags)
      }
      
      else{
        
      }
      
     });
     arr1.push(sum)
     setRows(arr)
     setRows1(arr1)
    
  }


 

function dateCheck(from,to,check) {

    var fDate,lDate,cDate;
    fDate = Date.parse(from);
    lDate = Date.parse(to);
    cDate = Date.parse(check);

    if((cDate <= lDate && cDate >= fDate)) {
        return true;
    }
    return false;
}


    const navigate = useNavigate();
    const columns = [
      { field: 'date', headerName: 'Date' , width: 150 ,
      valueFormatter: (params) => dayjs(params.value).format('DD/MM/YYYY')},
      {
          field: 'candidates',
          headerName: 'Benificiary Attended',
          width: 150 
          
        },
        { field: 'starterPacks', headerName: 'Starter Packs' , width: 90 },
        { field: 'nonClientFood', headerName: 'Non-Client Food Parcels' , width: 90 },
        { field: 'male', headerName: 'Male' , width: 90 },
        { field: 'female', headerName: 'Female' , width: 90 },
        { field: 'others', headerName: 'Other' , width: 90 },
      { field: 'meals', headerName: 'Hot Meals', width: 90 },
        { field: 'showers', headerName: 'Showers', width: 90 },
        { field: 'probaition', headerName: 'On Probation ' , width: 150 },
        { field: 'refugeeStarter', headerName: 'Refugee Starter Packs' , width: 150 },
        { field: 'sleepingBags', headerName: 'Sleeping Bags' , width: 150 },
        { field: 'name', headerName: 'Submitted By' , width: 150 },

    ];
    
    const columns1 = [
        { field: 'showers', headerName: 'Showers', width: 120 },
      { field: 'meals', headerName: 'Hot Meals', width: 120 },
      {
          field: 'candidates',
          headerName: 'Attended',
          width: 120 
          
        },
        { field: 'male', headerName: 'Male' , width: 120 },
        { field: 'female', headerName: 'Female' , width: 120 },
        { field: 'others', headerName: 'Other' , width: 120 },
        { field: 'probaition', headerName: 'Probation ' , width: 120 },

    ];
  
    const handleRowClick = (params) => {
      navigate("/profileStaff",{
        state: {
          employee: params.row,
        }
      });
    };

  return (
    <Box sx={{ display: 'flex' }}>
    <Sidebar />


    <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{ marginTop: "50px", justifyContent: "center", alignItems: "center" }}>

      <div style={{ height: 440, width: '100%' }}>
      <TextField type="date" InputLabelProps={{ shrink: true, }} className='addform' id="outlined-basic" label="Date" variant="outlined" style={{ width: "45%" }} onChange={(e) => setdate1(e.target.value)} value={date1} />
      <TextField type="date" InputLabelProps={{ shrink: true, }} className='addform' id="outlined-basic" label="Date" variant="outlined" style={{ width: "45%" }} onChange={(e) => setdate2(e.target.value)} value={date2} />
      <Button onClick={getData} className='addform' variant="contained" style={{ marginBottom: "10px", width: "100%", height: "50px", marginTop: "30px", backgroundColor: "#F21D2F" }}>Search</Button>
      <DataGrid 
                
                  rows={rows}
                  columns={columns}
                  pageSize={10}
                  rowsPerPageOptions={[5]}
                  //checkboxSelection
                 // onRowDoubleClick={handleRowClick}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
              />
      <div style={{height: "30vh"}}>
      <DataGrid 
                
                rows={rows1}
                columns={columns1}
                pageSize={1}
                rowsPerPageOptions={[1]}
                components={{
                  Toolbar: CustomToolbar,
                }}
            />
      </div>
    
    </div>
    </Box>
    </Box>
  )
}
